import { PrivateClubContextComponent } from './features/competitions/private-club-context.component';
import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';
import { leagueGuard } from './core/guards/league.guard';
import { LoginComponent } from './features/auth/login.component';
import { LeagueSelectionComponent } from './features/competitions/league-selection.component';
import { MainLayoutComponent } from './layout/main-layout.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { SquadComponent } from './features/squad/squad.component';
import { MarketComponent } from './features/transfers/market.component';
import { StadiumEconomyComponent } from './features/stadium/stadium-economy.component';
import { MatchEngineComponent } from './features/matches/match-engine.component';

import { NewsComponent } from './features/news/news.component';
import { SocialCallbackComponent } from './features/auth/social-callback.component';
import { RegisterComponent } from './features/auth/register.component';
import { VerifyEmailComponent } from './features/auth/verify-email.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [guestGuard],
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [guestGuard],
  },
  {
    path: 'auth/social/callback',
    component: SocialCallbackComponent,
  },
  {
    path: 'auth/verify-email',
    component: VerifyEmailComponent,
  },
  {
    path: 'leagues',
    component: LeagueSelectionComponent,
    canActivate: [authGuard],
  },
  {
    path: 'private-leagues/:leagueId/clubs/:clubId',
    component: PrivateClubContextComponent,
    canActivate: [authGuard],
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard, leagueGuard],
    children: [
      { path: '', redirectTo: 'competition', pathMatch: 'full' },
      { path: 'dashboard', redirectTo: 'competition', pathMatch: 'full' },
      { path: 'news', component: NewsComponent },
      { path: 'squad', component: SquadComponent },
      { path: 'competition', component: DashboardComponent },
      { path: 'market', component: MarketComponent },
      { path: 'club', component: StadiumEconomyComponent },
      { path: 'stadium', redirectTo: 'club', pathMatch: 'full' },
      { path: 'matchengine', component: MatchEngineComponent },
    ],
  },
  {
    path: '**',
    redirectTo: 'competition',
  },
];
